import { Link } from 'react-router-dom';
import Constant from '../Utils/Constant';

// Politique de confidentialité de l'application mobile OpenPeaks.
// URL publique requise par l'App Store / Google Play : /openpeaks/privacy
const PrivacyPage = () => {
    const { appName, lastUpdated, contactEmail, editor } = Constant.OPENPEAKS_PRIVACY;

    return (
        <div className="privacy-page">
            <div className="privacy-content">
                <div className="privacy-header">
                    <img
                        src="/openpeaks-logo.svg"
                        alt={`Logo ${appName}`}
                        className="privacy-logo"
                    />
                    <h1 className="privacy-title">Politique de confidentialité — {appName}</h1>
                </div>
                <p className="privacy-updated">Dernière mise à jour : {lastUpdated}</p>

                <section className="privacy-section">
                    <p>
                        {appName} est une application mobile permettant d'identifier les sommets
                        et sentiers de randonnée à proximité, à l'aide d'une boussole, d'une carte
                        interactive et d'une caméra en réalité augmentée. La présente politique
                        décrit la manière dont l'application traite vos données. En résumé :{' '}
                        <strong>{appName} ne collecte, ne stocke et ne transmet aucune donnée
                        personnelle vers un serveur.</strong>
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Position géographique</h2>
                    <p>
                        L'application utilise la localisation de votre appareil (GPS) pour
                        déterminer les sommets et sentiers proches de vous et afficher votre
                        position sur la carte. Cette position est traitée{' '}
                        <strong>uniquement sur votre appareil, en temps réel</strong>. Elle n'est
                        jamais enregistrée de façon permanente, jamais transmise à nos serveurs,
                        ni partagée avec un tiers.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Capteurs de mouvement</h2>
                    <p>
                        L'application accède à la boussole, au gyroscope et à l'accéléromètre pour
                        déterminer l'orientation de votre appareil et positionner correctement les
                        sommets dans la vue en réalité augmentée. Ces données de capteurs sont
                        utilisées en temps réel sur l'appareil et ne sont ni stockées ni transmises.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Caméra</h2>
                    <p>
                        L'application utilise la caméra pour afficher le paysage en arrière-plan de
                        la vue en réalité augmentée. Le flux vidéo est affiché en direct et n'est{' '}
                        <strong>jamais enregistré, capturé ni transmis</strong>.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Aucun suivi ni publicité</h2>
                    <p>
                        {appName} ne contient aucun traceur publicitaire, aucun outil d'analyse
                        d'audience et aucun identifiant de suivi. Aucune donnée personnelle n'est
                        collectée à des fins marketing ou statistiques.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Données téléchargées depuis Internet</h2>
                    <p>
                        Pour fonctionner, l'application télécharge des données cartographiques et de
                        terrain :
                    </p>
                    <ul>
                        <li>
                            Les fonds de carte sont fournis par <strong>Mapbox</strong>. Les requêtes
                            correspondantes sont soumises à la politique de confidentialité de Mapbox.
                        </li>
                        <li>
                            Les données d'élévation du terrain (SRTM, NASA/USGS) sont téléchargées
                            depuis un stockage public en lecture seule, sans authentification ni
                            transmission de données personnelles.
                        </li>
                        <li>
                            Les données des sommets et sentiers proviennent d'OpenStreetMap
                            (licence ODbL) et sont, pour l'essentiel, embarquées dans l'application
                            pour un usage hors ligne.
                        </li>
                    </ul>
                    <p>
                        Ces échanges réseau ne transmettent aucune information permettant de vous
                        identifier personnellement.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Stockage sur l'appareil</h2>
                    <p>
                        Vos préférences et les données cartographiques ou de terrain téléchargées
                        pour un usage hors ligne sont conservées <strong>localement sur votre
                        appareil</strong>. Elles peuvent être supprimées à tout moment depuis les
                        réglages de l'application ou en désinstallant celle-ci.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Enfants</h2>
                    <p>
                        {appName} ne s'adresse pas spécifiquement aux enfants et ne collecte
                        sciemment aucune donnée les concernant.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Modifications</h2>
                    <p>
                        Cette politique de confidentialité peut être mise à jour. Toute modification
                        sera publiée sur cette page, avec une date de mise à jour actualisée.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>Contact</h2>
                    <p>
                        Pour toute question relative à cette politique de confidentialité, vous
                        pouvez contacter {editor} à l'adresse{' '}
                        <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
                    </p>
                </section>

                <Link to="/" className="privacy-back-link">← Retour à l'accueil</Link>
            </div>
        </div>
    );
};

export default PrivacyPage;
